import { Module } from '../Module';
import { ServerService } from './ServerService';

/*
 * Determines which schedule-related actions a user has permission to perform.
 */
export class SchedulePermissions {

  public static $inject = ['ServerService'];

  constructor(private ServerService: ServerService) {
  }

  // This covers edit, rename, delete, enable/disable
  public canEditSchedule() {
    return this.ServerService.isSessionServerAdmin();
  }

  public canRunSchedule() {
    return this.ServerService.isSessionSiteOrServerAdmin();
  }

}

Module.instance().service('SchedulePermissions', SchedulePermissions);
